var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { INDRAExtraSidebar } from '@ibe.components/shared/sidebar-views/ancillaries/extra-sidebar.indra.abstract';
import { ANCILLARY_GROUP_SEAT_RESERVATION_LIST, ANCILLARY_GROUP_WHEELCHAIR_LIST, EXTRAS_ANCILLARY_SEAT, EXTRAS_ANCILLARY_SEAT_SSR, PAX_TYPE_INFANT_CODE, SEAT_PRICE_TICKET_AMOUNT_CODE, SSR_CODE_UNACCOMPANIED_MINOR, SSR_CODE_WHEELCHAIR_CARRY, SSR_CODE_WHEELCHAIR_STEPS, TAP_MILES_AND_GO_GOLD, TP_EXPRESS_PORTUGALIA, PAX_TYPE_CHILD_CODE, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SPECIAL_CASE_MARKET_LANGUAGE_MAP, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, ANCILLARY_PRODUCT_PACKS } from '@ibe.config';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAMybService } from '@ibe/services';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { PageScrollService } from 'ngx-page-scroll-core';
import { INDRASeatmapService } from '@ibe.services/seatmap.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { Seatmap } from '@ibe/models';
import { INDRACabinClass, INDRANewSeats, INDRAPlaneSeat, INDRAPlaneWing, INDRASeatColumn, SEAT_COLUMN_STATUS_AISLE, SEAT_COLUMN_STATUS_WINDOW } from '@ibe.models/seatmap.indra.model.lib';
import { INDRASlideshowComponent } from '@ibe.components/common/slideshow/slideshow.indra.component';
import { BehaviorSubject, forkJoin, throwError } from 'rxjs';
import { PURCHASED_ANCILLARY_SEAT } from '@ibe.components/shared/flight-brand-features-list/features.indra';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { catchError, filter, map, takeWhile, mergeMap } from 'rxjs/operators';
import * as _ from 'lodash';
// import { NewSeats, PlaneWing } from '@ibe.models/seatmap.model.lib';
// import { BookedTrip, Cabin, Flight, PassengerFlightInfo, PlaneSeat, SeatColumn } from '@ibe/models';
// import { BookingService, MybService } from '@ibe/services';
// import { TAPDataStorageService } from '@ibe/services/mocks.tap';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../../store';
// import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
// import { SeatmapComponent } from './seatmap.component';
// import { environment } from '@environments/environment';
// import { Brand } from '@ibe/models/ui';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import * as SeatmapActions from '@ibe/store/actions/seatmap.actions';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { planeSeatSpecifics, seatCharacteristicsDefault } from './data/seat-specifics';
import { INDRAPackService } from '../pack/pack.service.indra';
var INDRASeatmapComponent = /** @class */ (function (_super) {
    __extends(INDRASeatmapComponent, _super);
    function INDRASeatmapComponent(document, ibeAdminService, mybService, bfmService, cdr, modalService, pageScrollService, seatmapService, bookingService, _http, route, router, sidebarService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, ancillariesService, dateService, googleAnalytics, 
    //private storage: TAPDataStorageService,
    storageService, store, currencyService, currencyPipe, paymentInfoService, bookingSearchService, ibeAdminConfigService, packService) {
        var _this = _super.call(this, sidebarService, route, router, bookingService, mybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_SEAT, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService) || this;
        _this.document = document;
        _this.bfmService = bfmService;
        _this.cdr = cdr;
        _this.modalService = modalService;
        _this.pageScrollService = pageScrollService;
        _this.seatmapService = seatmapService;
        _this.bookingService = bookingService;
        _this._http = _http;
        _this.route = route;
        _this.router = router;
        _this.sidebarService = sidebarService;
        _this.ancillariesSelectionSrv = ancillariesSelectionSrv;
        _this.ancillariesShoppingCartSrv = ancillariesShoppingCartSrv;
        _this.ancillariesService = ancillariesService;
        _this.store = store;
        _this.currencyService = currencyService;
        _this.currencyPipe = currencyPipe;
        _this.paymentInfoService = paymentInfoService;
        _this.bookingSearchService = bookingSearchService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.packService = packService;
        _this._selectPassengerModalSubject = new BehaviorSubject(null);
        // @ViewChild('selectPassenger') $selectPassengerElem: ElementRef;
        // Initialization values
        // private bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
        _this.seatmapMock$ = _this.store.select(fromStore.getSeatmap);
        _this.seatCharacteristicsOpen = false;
        _this.emergencySeatNotificationOpen = false;
        _this.saveConfirmationInfoOpen = false;
        _this.hasChanges = false;
        _this.isAlive = true;
        _this.confirmToGoNext = false;
        _this.segmentApiErrors = [];
        _this.exitSeatClicked = false;
        _this.packSeatSelection = {};
        _this.addedByPack = false;
        _this.segmentsSeatmap = [];
        _this.seatmapCurrency = '';
        _this.planeSeatTypesList = new Set().add('standard');
        _this.seatCharacteristicsBySegmentBySeatTypeMap = new Map();
        _this.seatStyles = [];
        _this.hasEconomyCabin = false;
        _this.hasBusinessCabin = false;
        _this.stops = [];
        _this.airlinesAllowedChooseSeatMap = ['TP', 'NI', 'WI'];
        _this.choosedSeatsStops = [];
        _this.seatTypesArr = ['SEATEXTRA', 'SEATBUSS', 'SEATECON'];
        _this.newBoughtSeatsStops = [];
        _this.seatCharacteristics = JSON.parse(JSON.stringify(seatCharacteristicsDefault));
        _this.allSubscriptions = [];
        _this.isLoadingSeatmap = true;
        _this.isLoadingSegment = false;
        _this.allPaxAreUnaccompaniedMinor = false;
        _this.allPaxWithWCHC = false;
        _this.allPaxWithWCHCorWCHS = false;
        _this.isPortugaliaOperatedFlight = false;
        _this.hasHandicapped = false;
        _this.hasInfant = false;
        _this.hasUnaccompaniedMinor = false;
        _this.previouslyBoughtSeats = [];
        _this.previouslyBoughtSeatsBeforeEdit = [];
        _this.deletedPreviouslyBoughtSeats = [];
        _this.isModificationDisallowed = false;
        _this.loadedSubsription = _this.isLoaded.subscribe(function (res) {
            _this.isLoadingSeatmap = res;
            _this.cdr.detectChanges();
            _this.saveConfirmationInfoOpen = false;
            _this.cdr.detectChanges();
            if (res) {
                // store deleted previously purchased seat..
                // it will be used for checking the purchased seats if they are still valid to be displayed
                // this will be used until the details page is reloaded..
                _this.bfmService.INDRA_setDeletedPreviouslyPurchasedSeats(_this.deletedPreviouslyBoughtSeats);
            }
        });
        _this.allSubscriptions.push(_this.loadedSubsription);
        /*this.bookedTrip$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.booking = value;
                    this.initializeFlightDetails();
                }
            });

        this.seatmap$.pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.notSeatmap = false;
                    // Load plane
                    this.TAP_animatePlane();
                    // Save sidebar body element

                    this.seatmap = value;
                    if (this.seatmap !== undefined && this.seatmap.cabins[0].seatColumns !== undefined) {
                        this.planeSeatColumns = [...this.seatmap.cabins[0].seatColumns];
                        this.TAP_generateSeatStyle();
                    }
                } else {
                    // Finnished loading
                    this.notSeatmap = true;
                    this.seatmap = value;
                }
                setTimeout(() => {
                    this.isLoadingSeatmap = false;
                }, 3000);
            });
        */
        // get 'isBookingCreated' if existing in URL query params (if true, modification in the sidebar is not allowed)
        var isBookingCreatedParam = _this.route.snapshot.paramMap.get('isBookingCreated');
        if (isBookingCreatedParam === 'true') {
            _this.isModificationDisallowed = true;
        }
        return _this;
    }
    Object.defineProperty(INDRASeatmapComponent.prototype, "selectPassengerModal", {
        set: function (content) {
            var _this = this;
            setTimeout(function () {
                _this._selectPassengerModalSubject.next(content);
            }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRASeatmapComponent.prototype, "selectPassengerModalObservable", {
        get: function () {
            return this._selectPassengerModalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    INDRASeatmapComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var flightBased, passengers, handicappedCountWCHConly, handicappedCountWCHCandWCHS, unaccompaniedMinorCount, infantIndex, pnr, segmentIndex, firstSegmentId, firstSegment, passengerSidebarSubscription, i, segment, idInfoSegment, segment, idInfoSegment;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoadingSeatmap = true;
                        // this.$sidebarBody = document.getElementById('sidebar__body');
                        this.flightCardId = this.route.snapshot.paramMap.get('flight');
                        this.flight = this.bookingService.INDRA_getBookedFlight(this.flightCardId);
                        this.packCode = this.route.snapshot.paramMap.get('pack');
                        this.packSegment = this.route.snapshot.paramMap.get('packSegment');
                        flightBased = this.route.snapshot.paramMap.get('flightBasedPack');
                        if (flightBased === 'true') {
                            this.flightBasedPack = true;
                        }
                        else if (flightBased === 'false') {
                            this.flightBasedPack = false;
                        }
                        passengers = this.bookingService.INDRA_getPaxInfo();
                        handicappedCountWCHConly = 0;
                        handicappedCountWCHCandWCHS = 0;
                        unaccompaniedMinorCount = 0;
                        infantIndex = passengers.findIndex(function (pax) { return (pax.typePax === PAX_TYPE_INFANT_CODE); });
                        if (infantIndex >= 0) {
                            this.hasInfant = true;
                        }
                        this.passengers = passengers.filter(function (pax) {
                            var eligible = true;
                            // passenger type INF is not allowed to select an individual seat.. infant will occupy the same seat of their associated adult..
                            if (pax.typePax === PAX_TYPE_INFANT_CODE) {
                                eligible = false;
                            }
                            if (pax.prm) {
                                pax.prm.forEach(function (prmItem) {
                                    if (PURCHASED_ANCILLARY_SEAT.ineligibleSSR.includes(prmItem.type)) {
                                        eligible = false;
                                    }
                                });
                            }
                            if (eligible) {
                                return pax;
                            }
                        });
                        // associate adult to infant to validate seat selection
                        passengers.filter(function (pax) { return pax.typePax === PAX_TYPE_INFANT_CODE; }).forEach(function (pax) {
                            var resAdult = _this.passengers.find(function (x) { return x.idPax === pax.infToAdt; });
                            if (resAdult)
                                resAdult.adtToInf = pax.idPax;
                        });
                        // general checking of SSR codes for passengers in the PNR (UMNR and WCHC or WCHS)
                        // NOTE: WCHS is only applicable for seatmap wheelchair condition when the flight is operated by Portugalia (NI)
                        this.passengers.forEach(function (pax) {
                            if (pax.prm) {
                                var wchcFound_1 = false;
                                var wchsFound_1 = false;
                                var unaccompaniedMinor_1 = false;
                                pax.prm.forEach(function (prm) {
                                    if (SSR_CODE_UNACCOMPANIED_MINOR == prm.type) {
                                        unaccompaniedMinor_1 = true;
                                        _this.hasUnaccompaniedMinor = true;
                                    }
                                    if (SSR_CODE_WHEELCHAIR_CARRY == prm.type) {
                                        wchcFound_1 = true;
                                    }
                                    if (SSR_CODE_WHEELCHAIR_STEPS == prm.type) {
                                        wchsFound_1 = true;
                                    }
                                    if (ANCILLARY_GROUP_WHEELCHAIR_LIST.includes(prm.type)) {
                                        _this.hasHandicapped = true;
                                    }
                                });
                                if (wchcFound_1) {
                                    handicappedCountWCHConly++;
                                }
                                if (wchcFound_1 || wchsFound_1) {
                                    handicappedCountWCHCandWCHS++;
                                }
                                if (unaccompaniedMinor_1) {
                                    unaccompaniedMinorCount++;
                                }
                            }
                        });
                        if (handicappedCountWCHConly === this.passengers.length) {
                            this.allPaxWithWCHC = true;
                        }
                        if (handicappedCountWCHCandWCHS === this.passengers.length) {
                            this.allPaxWithWCHCorWCHS = true;
                        }
                        if (unaccompaniedMinorCount === this.passengers.length) {
                            this.allPaxAreUnaccompaniedMinor = true;
                        }
                        pnr = this.bfmService.INDRA_getActiveBookedTrip().data.pnr;
                        segmentIndex = 0;
                        firstSegmentId = 0;
                        this.isLoadingSeatmap = true;
                        firstSegment = this.flight.listSegment[0];
                        _super.prototype.ngOnInit.call(this);
                        this.initializePreviouslyBoughSeats();
                        this.INDRA_populateSeatmap(pnr);
                        passengerSidebarSubscription = this.selectPassengerModalObservable.pipe(filter(function (modal) { return !_.isNil(modal); })).subscribe(function (modal) {
                            modal.nativeElement.focus();
                        });
                        this.allSubscriptions.push(this.seatmapSubsription, passengerSidebarSubscription);
                        this.lowestPriceDisplay = this.INDRA_getPriceDisplay();
                        if (!(!this.packCode || (this.packCode && this.flightBasedPack))) return [3 /*break*/, 5];
                        // If seatmap is opened directly or pack is flight based, perform normal logic
                        // fills input for segmented control radio
                        this.isLoadingSegment = true;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.flight.listSegment.length)) return [3 /*break*/, 4];
                        segment = this.flight.listSegment[i];
                        this.stops.push({
                            label: segment.departureAirport + '-' + segment.arrivalAirport,
                            value: segmentIndex
                        });
                        idInfoSegment = segment.idInfoSegment;
                        if (segmentIndex === 0) {
                            firstSegmentId = idInfoSegment;
                        }
                        return [4 /*yield*/, this.INDRA_getSeatmapPerSegment(pnr, idInfoSegment, this.packCode)];
                    case 2:
                        _a.sent();
                        segmentIndex++;
                        if (i >= this.flight.listSegment.length - 1) {
                            this.isLoadingSegment = false;
                        }
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        segment = this.flight.listSegment.find(function (segment) { return segment.idInfoSegment == _this.packSegment; });
                        this.stops.push({
                            label: segment.departureAirport + '-' + segment.arrivalAirport,
                            value: segmentIndex
                        });
                        idInfoSegment = segment.idInfoSegment;
                        if (segmentIndex === 0) {
                            firstSegmentId = idInfoSegment;
                        }
                        return [4 /*yield*/, this.INDRA_getSeatmapPerSegment(pnr, idInfoSegment, this.packCode)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    INDRASeatmapComponent.prototype.INDRA_updateSeatCharacteristics = function (planeId) {
        var _this = this;
        this.seatCharacteristics = JSON.parse(JSON.stringify(seatCharacteristicsDefault));
        if (planeSeatSpecifics[planeId] != undefined && Object.keys(planeSeatSpecifics[planeId]).length > 0) {
            Object.keys(planeSeatSpecifics[planeId]).forEach(function (key) {
                if (planeSeatSpecifics[planeId][key].features) {
                    _this.seatCharacteristics[key].features = planeSeatSpecifics[planeId][key].features;
                }
                if (planeSeatSpecifics[planeId][key].images) {
                    _this.seatCharacteristics[key].images = planeSeatSpecifics[planeId][key].images;
                }
            });
        }
        else {
            Object.keys(planeSeatSpecifics.default).forEach(function (key) {
                if (planeSeatSpecifics.default[key].features) {
                    _this.seatCharacteristics[key].features = planeSeatSpecifics.default[key];
                }
                if (planeSeatSpecifics.default[key].images) {
                    _this.seatCharacteristics[key].images = planeSeatSpecifics.default[key].images;
                }
            });
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getSeatmapPerSegment = function (pnr, idInfoSegment, packCode) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.seatmapSubsription = _this.seatmapService.INDRA_getSeatmap(pnr, idInfoSegment, packCode).pipe(map(function (res) {
                var _a, _b;
                if (res.status === '200') {
                    var seatmap = new Seatmap();
                    seatmap.cabins = [];
                    seatmap = res.data ? res.data : res;
                    _this.segmentsSeatmap.push((_a = {},
                        _a[idInfoSegment] = seatmap,
                        _a.idInfoSegment = idInfoSegment,
                        _a));
                    _this.seatmapCurrency = seatmap.currency;
                    _this.aircraftFile = seatmap.aircraft_file;
                }
                else {
                    _this.segmentsSeatmap.push((_b = {},
                        _b[idInfoSegment] = undefined,
                        _b));
                    _this.seatmapCurrency = '';
                    _this.segmentApiErrors.push(idInfoSegment);
                    _this.isLoadingSeatmap = false;
                }
                if (_this.aircraftFile) {
                    _this.INDRA_updateSeatCharacteristics(_this.aircraftFile.split('.')[0]);
                }
                if (idInfoSegment !== 1) {
                    resolve(true);
                }
            }), mergeMap(function (res) { return _this.seatmapService.INDRA_getCabinTemplateURL(_this.aircraftFile); }))
                .pipe(catchError(function (error) { return throwError(error); }))
                .subscribe(function (data) {
                _this.INDRA_getSeatCharacteristicsForAircraft(idInfoSegment);
                if (!_this.selectedStop) {
                    if (_this.packCode && !_this.flightBasedPack) {
                        var stopIndex = _this.segmentApiErrors.findIndex(function (segment) { return segment.idInfoSegment === idInfoSegment; });
                        _this.INDRA_selectedStop(0, idInfoSegment);
                    }
                    else {
                        _this.INDRA_selectedStop(0); //first segment of the flight
                    }
                }
                resolve(true);
            }, function (error) {
                var _a;
                var errorIndex = _this.segmentsSeatmap.findIndex(function (o) { return o[idInfoSegment]; });
                if (errorIndex !== -1) {
                    _this.segmentsSeatmap[errorIndex] = (_a = {}, _a[idInfoSegment] = undefined, _a);
                }
                _this.seatmapCurrency = '';
                _this.segmentApiErrors.push(idInfoSegment);
                if (!_this.selectedStop) {
                    if (_this.packCode && !_this.flightBasedPack) {
                        _this.INDRA_selectedStop(0, idInfoSegment);
                    }
                    else {
                        _this.INDRA_selectedStop(0); //first segment of the flight
                    }
                }
                _this.INDRA_getSeatCharacteristicsForAircraft(idInfoSegment);
                resolve(true);
            });
            // this.seatmapSubsription = this.seatmapService.INDRA_getSeatmap(pnr, idInfoSegment).subscribe(
            // 	res => {
            // 		if (res.status === '200') {
            // 			let seatmap = new Seatmap();
            // 			seatmap.cabins = [];
            // 			seatmap = res.data ? res.data : res;
            // 			this.segmentsSeatmap.push({
            // 				[idInfoSegment]: seatmap
            // 			});
            // 			this.seatmapCurrency = seatmap.currency;
            // 			this.aircraftFile = seatmap.aircraft_file;
            // 			this.seatmapService.INDRA_getCabinTemplateURL(this.aircraftFile)
            // 				.pipe(catchError(error => throwError(error)))
            // 				.subscribe(data => {
            // 					//dispatch LoadAircraftJSONAction
            // 					this.store.dispatch(
            // 						new SeatmapActions.LoadAircraftJSONAction({ aircraftFile: this.aircraftFile })
            // 					);
            // 				}, error => {
            // 					this.segmentsSeatmap = [{
            // 						[idInfoSegment]: undefined
            // 					}];
            // 					this.seatmapCurrency = '';
            // 					this.segmentApiErrors.push(idInfoSegment);
            // 				})
            // 		} else {
            // 			this.segmentsSeatmap.push({
            // 				[idInfoSegment]: undefined
            // 			});
            // 			this.seatmapCurrency = '';
            // 			this.segmentApiErrors.push(idInfoSegment);
            // 		}
            // 		if (!this.selectedStop) {
            // 			this.INDRA_selectedStop(0); //first segment of the flight
            // 		}
            // 		this.INDRA_getSeatCharacteristicsForAircraft(idInfoSegment);
            // 		resolve(true);
            // 	}, error => {
            // 		this.segmentsSeatmap.push({
            // 			[idInfoSegment]: undefined
            // 		});
            // 		if (!this.selectedStop) {
            // 			this.INDRA_selectedStop(0); //first segment of the flight
            // 		}
            // 		this.seatmapCurrency = '';
            // 		this.segmentApiErrors.push(idInfoSegment);
            // 		this.INDRA_getSeatCharacteristicsForAircraft(idInfoSegment);
            // 		resolve(true);
            // 	});
        });
    };
    INDRASeatmapComponent.prototype.initializePreviouslyBoughSeats = function () {
        var _this = this;
        // retrieves purchased seat  (ancillaries.journey)
        this.previouslyBoughtSeatsBeforeEdit = this.bookingService.INDRA_getPurchasedSeatDetails(this.flight.idFlight, this.flightCardId);
        this.previouslyBoughtSeats = this.previouslyBoughtSeatsBeforeEdit.slice();
        // filter deleted purchased seat list..
        var deletedPurchasedSeats = this.bfmService.INDRA_getDeletedPreviouslyPurchasedSeats();
        this.deletedPreviouslyBoughtSeats = deletedPurchasedSeats.slice();
        if (this.deletedPreviouslyBoughtSeats && this.deletedPreviouslyBoughtSeats.length > 0) {
            this.previouslyBoughtSeats = this.previouslyBoughtSeats.filter(function (previouslyBoughtSeat) {
                var index = _this.deletedPreviouslyBoughtSeats.findIndex(function (deletedSeat) {
                    return (deletedSeat.flightId === previouslyBoughtSeat.flightId &&
                        deletedSeat.segmentId === previouslyBoughtSeat.segmentId &&
                        deletedSeat.paxId === previouslyBoughtSeat.paxId &&
                        deletedSeat.value === previouslyBoughtSeat.value);
                });
                if (index === -1) {
                    return previouslyBoughtSeat;
                }
            });
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getSeatCharacteristics = function (idInfoSegment, seatType) {
        return this.seatCharacteristicsBySegmentBySeatTypeMap.get(idInfoSegment).get(seatType);
    };
    INDRASeatmapComponent.prototype.INDRA_getKeyBySeatType = function (seatType) {
        switch (seatType) {
            case 'SEATEXTRA':
                return 'preferred';
            case 'SEATECON':
                return 'standard';
            case 'SEATBUSS':
                return 'business';
        }
    };
    /**
    *  Populates choosedSeats with seats
    *  found in session storage
    */
    INDRASeatmapComponent.prototype.INDRA_populateSeatmap = function (pnr) {
        var _this = this;
        this.shoppingCartSubsription = this.ancillariesShoppingCartSrv.INDRA_getAncillariesShoppingCart(pnr).subscribe(function (result) {
            if (_this.flight) {
                // note: used flightCardId instead of flightId since using flightId will be problematic for stopover scenarios
                _this.featuresAddedBeforeEdit = result.itemsAdded.filter(function (item) { return +item.flightCardId === +_this.flight.assignedFlightId; });
                _this.featuresAdded = _this.featuresAddedBeforeEdit.slice();
                // filter purchased seat list if a new item has been added already on the shopping cart for the passenger..
                if (_this.featuresAddedBeforeEdit && _this.featuresAddedBeforeEdit.length > 0) {
                    _this.previouslyBoughtSeats = _this.previouslyBoughtSeats.filter(function (previouslyBoughtSeat) {
                        var index = _this.featuresAddedBeforeEdit.findIndex(function (addedFeature) {
                            return (addedFeature.flightId === previouslyBoughtSeat.flightId &&
                                addedFeature.segmentId === previouslyBoughtSeat.segmentId &&
                                addedFeature.paxId === previouslyBoughtSeat.paxId &&
                                addedFeature.value === previouslyBoughtSeat.value);
                        });
                        if (index === -1) {
                            return previouslyBoughtSeat;
                        }
                    });
                }
                _this.featuresCurrencyCode = result.currencyCode;
                var passengers_1 = _this.INDRA_getPassengers();
                _this.featuresAdded.forEach(function (feature) {
                    var passengerIndex = passengers_1.findIndex(function (passenger) {
                        return passenger.idPax === feature.paxId;
                    });
                    if (feature.type === EXTRAS_ANCILLARY_SEAT) {
                        var stopIndex_1 = _this.flight.listSegment.findIndex(function (segment) { return segment.idInfoSegment === feature.segmentId; });
                        // note: only proceed with plotting seats if there is a correct stopIndex
                        if (stopIndex_1 > -1) {
                            var choosedSeats = _this.choosedSeatsStops.find(function (cur) { return cur.id_stop == stopIndex_1; });
                            if (choosedSeats) {
                                choosedSeats.seats.push({
                                    passengerIndex: passengerIndex,
                                    seat: feature.value,
                                    price: feature.price,
                                    points: feature.points,
                                    seatDescription: feature.seatDescription,
                                    seatType: feature.seatType
                                });
                            }
                            else {
                                var choosed = [];
                                choosed.push({
                                    passengerIndex: passengerIndex,
                                    seat: feature.value,
                                    price: feature.price,
                                    points: feature.points,
                                    seatDescription: feature.seatDescription,
                                    seatType: feature.seatType
                                });
                                _this.choosedSeatsStops.push({
                                    id_stop: stopIndex_1,
                                    seats: choosed
                                });
                            }
                            var newBoughtSeats = _this.newBoughtSeatsStops.find(function (cur) { return cur.id_stop == stopIndex_1; });
                            if (newBoughtSeats) {
                                newBoughtSeats.seats.push({
                                    passengerIndex: passengerIndex,
                                    seat: feature.value,
                                    price: feature.price,
                                    points: feature.points,
                                    seatDescription: feature.seatDescription,
                                    seatType: feature.seatType
                                });
                            }
                            else {
                                var newBought = [];
                                newBought.push({
                                    passengerIndex: passengerIndex,
                                    seat: feature.value,
                                    price: feature.price,
                                    points: feature.points,
                                    seatDescription: feature.seatDescription,
                                    seatType: feature.seatType
                                });
                                _this.newBoughtSeatsStops.push({
                                    id_stop: stopIndex_1,
                                    seats: newBought
                                });
                            }
                        }
                    }
                });
            }
        });
        this.allSubscriptions.push(this.shoppingCartSubsription);
    };
    INDRASeatmapComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    /**
     * Scroll page to plane
     */
    INDRASeatmapComponent.prototype.INDRA_animatePlane = function () {
        var _this = this;
        // Scroll to plane
        setTimeout(function () {
            var PLANE_SEAT_ROWS_START = document.getElementsByClassName('seatmap__row')[0];
            if (PLANE_SEAT_ROWS_START) {
                // PLANE_SEAT_ROWS_START.scrollIntoView({
                // 	behavior: 'smooth',
                // 	block: 'start'
                // });
                _this.pageScrollService.scroll({
                    document: _this.document,
                    scrollViews: [_this.document.getElementById('sidebar__body')],
                    scrollTarget: '.seatmap__row',
                    duration: 400
                });
            }
        }, 1000);
    };
    INDRASeatmapComponent.prototype.initializeSeatmap = function (cabinType) {
        var _this = this;
        var hasBusinessCabin = Object.is(cabinType, 'Business');
        if (this.seatmap !== undefined
            && this.seatmap.cabins
            && this.seatmap.cabins.length > 0) {
            if (this.seatmap.cabins[0].seatColumns !== null
                && this.seatmap.cabins[0].seatColumns !== undefined) {
                if (hasBusinessCabin && !_.isNil(this.seatmapMock) && !_.isEmpty(this.seatmapMock.cabins)) {
                    var mockPlaneCabins_1 = this.seatmapMock.cabins;
                    this.planeSeatColumns = this.seatmapMock.cabins[0].seatColumns.map(function (sColumns) {
                        return _this.mapMockColumnToPlaneSeatColumn(sColumns);
                    });
                    this.seatmap.cabins.forEach(function (cabin) {
                        var firstRow = cabin.firstRow - 1;
                        var lastRow = cabin.lastRow;
                        var cabinsToGetLayout = mockPlaneCabins_1.slice(firstRow, lastRow);
                        cabin.seatColumns = _this.planeSeatColumns;
                        cabin.rows.forEach(function (row, index) {
                            var cabinRowMock = cabinsToGetLayout[index];
                            var rowLayout = _.first(cabinRowMock.rows);
                            // check mock row if exit row then update seat exit value
                            var mockRowIsExitRow = cabinRowMock.facilities.some(function (facil) { return facil.type === 'E'; });
                            if (mockRowIsExitRow) {
                                row.seatsByCode.forEach(function (seat, i) {
                                    row.seatsByCode[i] = Object.assign(seat, { exit: true });
                                });
                            }
                            // checks missing seat exit value based on seatmap of api
                            var isExitRow = row.seatsByCode.some(function (seat) { return seat.exit === true; });
                            // assign facilities E and LA to business rows from mock to seatmap
                            if (!row.facilities && _this.seatmapMock && _this.seatmapMock['cabins']) {
                                row.facilities = _this.seatmapMock.cabins[index].facilities;
                            }
                            // there's a missing seat if number of columns is not the same with seatsByCode size of the row
                            //if (row.seatsByCode.length !== planeSeatColumns.length) {
                            var newSeatsByCodeForCurrentRow = [];
                            var seatIndexForRow = 0;
                            // this will
                            _this.planeSeatColumns.forEach(function (column) {
                                var columnMock = cabinRowMock.seatColumns.find(function (sColumnMock) { return Object.is(column.index, sColumnMock.index); });
                                var seatRowIndex = row.seatsByCode.findIndex(function (seat) { return seat.seatCode.includes(column.index); });
                                var seatsByCodeElementMock = rowLayout.seatsByCode[seatRowIndex];
                                var seatByCodeElementReal = row.seatsByCode[seatRowIndex];
                                if (!_.isNil(seatsByCodeElementMock)) {
                                    newSeatsByCodeForCurrentRow[seatIndexForRow] = __assign({}, seatsByCodeElementMock, { class: columnMock.class, prices: seatByCodeElementReal.prices, exit: mockRowIsExitRow ? seatByCodeElementReal.exit : isExitRow, available: seatByCodeElementReal.available, extraLegSpace: seatByCodeElementReal.extraLegSpace, chargeable: seatByCodeElementReal.chargeable, allowedInfant: seatByCodeElementReal.allowedInfant, allowedMedical: seatByCodeElementReal.allowedMedical, allowedUnnacompaniedMinor: seatByCodeElementReal.allowedUnnacompaniedMinor, suitableUnnacompaniedMinor: seatByCodeElementReal.suitableUnnacompaniedMinor, suitableChildren: seatByCodeElementReal.suitableChildren, handicappedFacilities: seatByCodeElementReal.handicappedFacilities, allowedBassinet: seatByCodeElementReal.allowedBassinet, characteristics: seatByCodeElementReal.characteristics, seatDescription: seatByCodeElementReal.seatDescription, type: seatByCodeElementReal.type });
                                    seatIndexForRow++;
                                }
                            });
                            row.seatsByCode = newSeatsByCodeForCurrentRow.slice();
                            // }
                        });
                    });
                }
                else {
                    this.planeSeatColumns = this.seatmap.cabins[0].seatColumns;
                    // massaging of data if in case seat in rows are not in-line with number of seat clumns
                    this.seatmap.cabins.forEach(function (cabin) {
                        cabin.rows.forEach(function (row) {
                            // there's a missing seat if number of columns is not the same with seatsByCode size of the row
                            if (row.seatsByCode.length !== _this.planeSeatColumns.length) {
                                var newSeatsByCodeForCurrentRow_1 = [];
                                var seatIndexForRow_1 = 0;
                                // this will
                                // check if missing seat is in the emergency exit row
                                var isExitRow_1 = row.seatsByCode.some(function (seat) { return seat.exit === true; });
                                _this.planeSeatColumns.forEach(function (column) {
                                    var seatRowIndex = row.seatsByCode.findIndex(function (seat) { return seat.seatCode.includes(column.index); });
                                    if (seatRowIndex === -1) {
                                        // creates a seat object for the missing seat..
                                        newSeatsByCodeForCurrentRow_1[seatIndexForRow_1] = {
                                            seatCode: row.index + column.index,
                                            available: false,
                                            missing: true,
                                            extraLegSpace: false,
                                            exit: isExitRow_1,
                                            chargeable: false,
                                            allowedInfant: false,
                                            allowedMedical: false,
                                            allowedUnnacompaniedMinor: false,
                                            suitableUnnacompaniedMinor: false,
                                            suitableChildren: false,
                                            handicappedFacilities: false,
                                            allowedBassinet: false,
                                            preferredSeat: false,
                                            prices: [],
                                            characteristics: []
                                        };
                                    }
                                    else {
                                        // just place the existing seat on its necessary position..
                                        newSeatsByCodeForCurrentRow_1[seatIndexForRow_1] = __assign({}, row.seatsByCode[seatRowIndex], { empty: row.seatsByCode[seatRowIndex].missing });
                                    }
                                    seatIndexForRow_1++;
                                });
                                row.seatsByCode = newSeatsByCodeForCurrentRow_1.slice();
                            }
                            // seatmap from api has no empty property
                            // assign empty seats for ECONOMY cabin only from seatmapMock
                            row.seatsByCode.forEach(function (seat, i) {
                                if (_this.seatmapMock && _this.seatmapMock['cabins']) {
                                    _this.seatmapMock.cabins.forEach(function (cab) {
                                        if (cab.rows[0].index == row.index) {
                                            cab.rows[0].seatsByCode.forEach(function (el) {
                                                if (el.seatCode === seat.seatCode) {
                                                    row.seatsByCode[i] = Object.assign(row.seatsByCode[i], { empty: el['empty'] });
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        });
                    });
                    if (this.seatmapMock && this.seatmapMock.cabins.length && this.seatmapMock['facilities']) {
                        var mockFacilityLAFirstRow = this.seatmapMock['facilities'].filter(function (facility) { return facility.seat === 'init' && facility.type === 'LA'; });
                        var mockFacilityExitFirstRow_1 = this.seatmapMock.cabins[0].facilities.filter(function (facility) { return facility.type === 'E' && facility.rowLocation === 1; });
                        if (mockFacilityLAFirstRow) {
                            this.seatmap.cabins.forEach(function (cabin) {
                                cabin.rows.forEach(function (row, i) {
                                    if (row.index === 1) {
                                        cabin.facilities = [{
                                                rowLocation: 'WC Before Row:' + row.index.toString(),
                                                type: 'WC',
                                                location: row.index
                                            }];
                                        if (mockFacilityExitFirstRow_1) {
                                            row.facilities = [__assign({}, mockFacilityExitFirstRow_1[0])];
                                        }
                                    }
                                });
                            });
                        }
                    }
                }
            }
            else {
                this.planeSeatColumns = [];
            }
            this.INDRA_generateCabinStyle();
            // handle missing or misplaced WC/LA for business cabins
            if (this.seatmapMock && this.seatmapCabinClass === 'business' && !_.isNil(this.seatmapMock) && !_.isEmpty(this.seatmapMock.cabins)) {
                var mockRow_1 = this.seatmapMock.cabins.filter(function (cabins) { return cabins.facilities.some(function (c) {
                    return c.location === '1' && c.type === 'WC';
                }); });
                if (mockRow_1.length > 0) {
                    this.seatmap.cabins.forEach(function (cab) {
                        cab.facilities.forEach(function (el, i) {
                            if (el.location === mockRow_1[0].facilities[i].location &&
                                el.type === mockRow_1[0].facilities[i].type &&
                                el.rowLocation != mockRow_1[0].facilities[i].rowLocation) {
                                el.rowLocation = mockRow_1[0].facilities[i].rowLocation;
                            }
                        });
                    });
                }
                // FILTER WC/LA LOCATIONS FROM MOCK facilities and assign to seatmap BUSINESS CABIN
                var businessMockLALocations_1 = [];
                if (this.seatmapMock && this.seatmapMock['facilities']) {
                    this.seatmapMock['facilities'].forEach(function (el) {
                        if (el.type === 'LA') {
                            businessMockLALocations_1.push(el.seat);
                        }
                    });
                }
                if (businessMockLALocations_1.length > 0) {
                    this.seatmap.cabins.forEach(function (cabs) {
                        cabs.rows.forEach(function (row) {
                            if ((businessMockLALocations_1.includes(row.index) && !cabs.facilities) ||
                                (businessMockLALocations_1.includes('init') && row.index === 1)) {
                                cabs.facilities = [{
                                        rowLocation: row.index > 1 ? 'WC After Row:' + row.index.toString() : 'WC Before Row:' + row.index.toString(),
                                        type: 'WC',
                                        location: row.index
                                    }];
                            }
                        });
                    });
                }
            }
            // check for missing WC/LA in ECONOMY from mock and assign to seatmap
            var economyLALocations_1 = [];
            if (this.seatmapMock && this.seatmapCabinClass === 'economy' && this.seatmapMock['facilities'] && this.seatmapMock['facilities'].length) {
                this.seatmapMock['facilities'].forEach(function (el) {
                    if (el.type === 'LA' && !isNaN(el.seat)) {
                        economyLALocations_1.push(el.seat);
                    }
                });
                // if json row with WC is found on seatmap row from api, add
                // a WC facility to that row
                if (economyLALocations_1.length > 0) {
                    this.seatmap.cabins.forEach(function (cabs) {
                        cabs.rows.forEach(function (row) {
                            if (economyLALocations_1.includes(row.index) && !cabs.facilities) {
                                cabs.facilities = [{
                                        rowLocation: row.index > 1 ? 'WC After Row:' + row.index.toString() : 'WC Before Row:' + row.index.toString(),
                                        type: 'WC',
                                        location: row.index
                                    }];
                            }
                        });
                    });
                }
            }
            // api is always returning WC 'after'
            // massage data from api to correct WC location if located on first row
            this.seatmap.cabins.forEach(function (cabs) {
                if (cabs.facilities && cabs.facilities.length) {
                    cabs.facilities.forEach(function (facility) {
                        if (facility.location == '1' && facility.rowLocation === 'WC After Row:1') {
                            facility.rowLocation = 'WC Before Row:';
                        }
                    });
                }
            });
            // Finnished loading
            this.isLoadingSeatmap = false;
            this.cdr.detectChanges();
            // Load plane
            this.INDRA_animatePlane();
        }
        else {
            this.isLoadingSeatmap = false;
            this.cdr.detectChanges();
            // this.segmentApiErrors.push(0)
        }
    };
    INDRASeatmapComponent.prototype.mapMockColumnToPlaneSeatColumn = function (sColumns) {
        var status;
        if (Object.is('W', sColumns.status)) {
            status = 'WINDOW';
        }
        else if (Object.is('C', sColumns.status)) {
            status = 'CENTER';
        }
        else {
            status = 'AISLE';
        }
        return __assign({}, sColumns, { status: status });
    };
    INDRASeatmapComponent.prototype.INDRA_printSidebarTitle = function () {
        if (this.seatCharacteristicsOpen) {
            return this.INDRA_getTranslation('addMoreSidebars.seatmap.title.compareSeats');
        }
        else if (this.emergencySeatNotificationOpen) {
            return this.INDRA_getTranslation('addMoreSidebars.seatmap.title.emergencySeat');
        }
        else if (this.saveConfirmationInfoOpen) {
            return this.INDRA_getTranslation('addMoreSidebars.seatmap.title.importantInfo');
        }
        else {
            return this.INDRA_getTranslation('addMoreSidebars.seatmap.title.seatMap');
        }
    };
    INDRASeatmapComponent.prototype.INDRA_printSeatPhotosAriaLabel = function () {
        return this.INDRA_getTranslation('addMoreSidebars.seatmap.link.seatPhotosOpensAWindow');
    };
    INDRASeatmapComponent.prototype.INDRA_printSidebarLabel = function () {
        if (this.seatCharacteristicsOpen ||
            this.emergencySeatNotificationOpen ||
            this.saveConfirmationInfoOpen) {
            return '';
        }
        else {
            return (this.lowestPriceDisplay ? this.lowestPriceDisplay : '');
        }
    };
    INDRASeatmapComponent.prototype.INDRA_handleClose = function () {
        this.selectionApiError = false;
        if (this.seatCharacteristicsOpen) {
            this.seatCharacteristicsOpen = false;
        }
        else if (this.emergencySeatNotificationOpen) {
            this.emergencySeatNotificationOpen = false;
        }
        else if (this.saveConfirmationInfoOpen) {
            this.hasChanges = true;
            this.saveConfirmationInfoOpen = false;
        }
        else if (this.hasChanges) {
            this.saveScrollPosition();
            this.topScrollPosition();
            this.hasChanges = false;
            this.saveConfirmationInfoOpen = true;
        }
        else {
            this.sidebarService.previousSidebar();
            return;
        }
        // If sidebar still open, restore scroll
        this.restoreScrollPosition();
    };
    // Save scroll position
    INDRASeatmapComponent.prototype.saveScrollPosition = function () {
        this.savedScrollPosition = this.$sidebarBody.scrollTop;
    };
    INDRASeatmapComponent.prototype.restoreScrollPosition = function () {
        var _this = this;
        setTimeout(function () {
            _this.$sidebarBody.scrollTop = _this.savedScrollPosition;
        }, 10);
    };
    // Goes to top scroll position
    INDRASeatmapComponent.prototype.topScrollPosition = function () {
        var _this = this;
        setTimeout(function () {
            _this.$sidebarBody.scrollTop = 0;
        }, 10);
    };
    INDRASeatmapComponent.prototype.INDRA_showSaveSidebarHeader = function () {
        return (this.hasChanges &&
            !this.seatCharacteristicsOpen &&
            !this.emergencySeatNotificationOpen);
    };
    INDRASeatmapComponent.prototype.INDRA_saveSidebar = function () {
        this.hasChanges = false;
        this.saveScrollPosition();
        this.topScrollPosition();
        this.INDRA_addAncillariesSelection();
        this.selectionApiError = false;
        this.saveConfirmationInfoOpen = true;
    };
    INDRASeatmapComponent.prototype.INDRA_getSeatCharacteristicsForAircraft = function (idInfoSegment) {
        var _this = this;
        var finalMap = new Map();
        var seatTypes = [];
        var asyncCalls = [];
        var segmentInCause = this.flight.listSegment.filter(function (segment) { return segment.idInfoSegment === +idInfoSegment; })[0];
        for (var i = 0; i < this.seatTypesArr.length; i++) {
            var fareReq = {
                origin: segmentInCause.departureAirport,
                destination: segmentInCause.arrivalAirport,
                aircraft: +segmentInCause.equipment,
                fareBasis: [this.seatTypesArr[i]],
                fareFamily: [this.seatTypesArr[i]],
                operatingCarrier: segmentInCause.carrier,
                itinerary: [{
                        carrier: segmentInCause.carrier,
                        equipment: segmentInCause.equipment,
                        departureDate: segmentInCause.departureDate,
                        origin: segmentInCause.departureAirport,
                        destination: segmentInCause.arrivalAirport,
                        operationCarrier: segmentInCause.operationCarrier,
                        rbd: '*'
                    }]
            };
            asyncCalls.push(this.ancillariesService.INDRA_getFareInformationTAC(fareReq));
            seatTypes.push(this.seatTypesArr[i] + '');
        }
        var observable = forkJoin(asyncCalls);
        observable.subscribe({
            next: function (value) { return value.forEach(function (resp) {
                finalMap.set(_this.INDRA_getKeyBySeatType(seatTypes[value.indexOf(resp)]), resp.fareInformationData[0].ancillaries.map(function (str) { return str.split('-')[1]; }));
            }); },
        });
    };
    INDRASeatmapComponent.prototype.INDRA_selectedStop = function (value, idInfoSegment) {
        var _this = this;
        this.selectionApiError = false;
        this.selectedStop = value;
        this.flightStop = this.flight.listSegment[value];
        if (idInfoSegment) {
            // Different segment from seats
            this.flightStop = this.flight.listSegment.find(function (segment) { return segment.idInfoSegment === idInfoSegment; });
        }
        var currentSegment = this.segmentsSeatmap[value];
        var aircraftFile = null;
        if (this.segmentsSeatmap[value][this.flightStop.idInfoSegment] === undefined) {
            this.store.dispatch(new SeatmapActions.LoadAircraftJSONAction({ aircraftFile: aircraftFile }));
            this.seatmap = undefined;
            this.selectionApiError = true;
        }
        else {
            aircraftFile = this.segmentsSeatmap[value][currentSegment.idInfoSegment].aircraft_file;
            // dispatch LoadAircraftJSONAction
            this.store.dispatch(new SeatmapActions.LoadAircraftJSONAction({ aircraftFile: aircraftFile }));
            if (aircraftFile) {
                this.INDRA_updateSeatCharacteristics(aircraftFile.split('.')[0]);
            }
            // this.INDRA_updateSeatCharacteristicsMap(this.flightStop.idInfoSegment);
            //this.seatCharacteristics['business'].features = this.bookingService.INDRA_getBusinessFeatures(this.flightStop.equipment);
            var seatmapIndex = this.segmentsSeatmap.findIndex(function (object) { return object[_this.flightStop.idInfoSegment]; });
            var segmentSeatmapObject = this.segmentsSeatmap[seatmapIndex];
            if (seatmapIndex !== -1) {
                this.seatmap = segmentSeatmapObject[this.flightStop.idInfoSegment];
            }
            else {
                this.seatmap = undefined;
            }
            // check if flight segment is a Portugalia flight
            this.isPortugaliaOperatedFlight = (this.flightStop.operationCarrier == TP_EXPRESS_PORTUGALIA);
            var choosedSeats = this.choosedSeatsStops.find(function (cur) { return cur.id_stop == _this.selectedStop; });
            var newBoughtSeats = this.newBoughtSeatsStops.find(function (cur) { return cur.id_stop == _this.selectedStop; });
            this.choosedSeats = choosedSeats ? choosedSeats.seats : [];
            this.newBoughtSeats = newBoughtSeats ? newBoughtSeats.seats : [];
            // load mock seatmap when changing segment
            this.seatmapMock$.pipe(takeWhile(function () { return _this.isAlive; }), filter(function (val) { return !_.isNil(val); }))
                .subscribe(function (val) {
                _this.seatmapMock = val;
                var cabinType = _this.flightStop.cabin;
                _this.initializeSeatmap(cabinType);
            });
            this.$sidebarBody = document.getElementById('sidebar__body');
            this.INDRA_checkAncillaryInPack();
        }
    };
    INDRASeatmapComponent.prototype.INDRA_avaibleForFlight = function () {
        return this.seatmap !== undefined;
    };
    INDRASeatmapComponent.prototype.INDRA_letterStyle = function (column, index) {
        return {
            'alley-left': column.status === SEAT_COLUMN_STATUS_AISLE &&
                this.planeSeatColumns[index - 1].status === SEAT_COLUMN_STATUS_AISLE,
            'alley-right': column.status === SEAT_COLUMN_STATUS_AISLE &&
                this.planeSeatColumns[index + 1].status === SEAT_COLUMN_STATUS_AISLE,
            'window-left': column.status === SEAT_COLUMN_STATUS_WINDOW && index === 0,
            'window-right': column.status === SEAT_COLUMN_STATUS_WINDOW && index !== 0
        };
        // phase 2 TODO check if we need to update logic
        /* return {
            'alley-left':
                column.status === 'A' &&
                this.planeSeatColumns[index - 1].status === 'A',
            'alley-right':
                column.status === 'A' &&
                this.planeSeatColumns[index + 1].status === 'A',
            'window-left': column.status === 'W' && index === 0,
            'window-right': column.status === 'W' && index !== 0
        }; */
    };
    INDRASeatmapComponent.prototype.INDRA_seatmapIsLoadded = function () {
        return this.seatmap !== undefined;
    };
    INDRASeatmapComponent.prototype.INDRA_showCabinClassEconomyContainer = function () {
        return !this.hasEconomyCabin;
    };
    INDRASeatmapComponent.prototype.INDRA_showCabinClassBusinessContainer = function () {
        return !this.hasBusinessCabin;
    };
    INDRASeatmapComponent.prototype.trackByFn = function (index, item) {
        if (!item) {
            return null;
        }
        return index;
    };
    /*INDRA_seatHasPassenger(seat: INDRAPlaneSeat): boolean {
        if (this.flightStop) {
            let purchasedStopSeats = this.previouslyBoughtSeats.filter(paxSeatItem => (paxSeatItem.segmentId === this.flightStop.idInfoSegment && seat.seatCode === paxSeatItem.value));
            if (purchasedStopSeats.length > 0) {
                return purchasedStopSeats.length > 0;
            } else {
                return (this.choosedSeats.filter(choosedSeat => choosedSeat.seat === seat.seatCode)[0] !== undefined);
            }
        }
        //return (this.choosedSeats.filter(choosedSeat => choosedSeat.seat === seat.seatCode)[0] !== undefined);
    }*/
    INDRASeatmapComponent.prototype.INDRA_handleSeatClick = function (seat) {
        var _this = this;
        if (seat.isClicked) {
            var sameSeatSelected = this.previouslyBoughtSeatsBeforeEdit.some(function (paxSeatItem) { return seat.seatCode === paxSeatItem.value; });
            if (!sameSeatSelected) {
                var isPreviouslyBought = false;
                var boughtSeatIndex = this.previouslyBoughtSeatsBeforeEdit.findIndex(function (boughtSeat) { return boughtSeat.value === seat.seatCode && boughtSeat.segmentId === _this.flightStop.idInfoSegment; });
                var addedSeatIndex = this.featuresAddedBeforeEdit.findIndex(function (boughtSeat) { return boughtSeat.value === seat.seatCode && boughtSeat.segmentId === _this.flightStop.idInfoSegment; });
                if (boughtSeatIndex > -1 || addedSeatIndex > -1) {
                    isPreviouslyBought = true;
                }
                var previouslyBoughtSeatIndexForSplice = this.previouslyBoughtSeats.findIndex(function (boughtSeat) { return boughtSeat.value === seat.seatCode && boughtSeat.segmentId === _this.flightStop.idInfoSegment; });
                /**
                 * Seat not available **
                 *
                 */
                if ((!seat.available && !isPreviouslyBought) ||
                    seat.missing ||
                    // unaccompanied minor can only select seats that are suitable for UMNR..
                    (this.allPaxAreUnaccompaniedMinor && !seat.suitableUnnacompaniedMinor) ||
                    // if all pax are with WCHC (or WCHS if Portugalia flight) they can only select seats that are suitable for handicapped..
                    ((this.allPaxWithWCHC || (this.allPaxWithWCHCorWCHS && this.isPortugaliaOperatedFlight)) && !seat.handicappedFacilities)) {
                    return;
                }
                /**
                 * Seat available **
                 */
                var SEAT_WITH_PAX_1 = this.choosedSeats.findIndex(function (choosedSeat) { return choosedSeat.seat === seat.seatCode; });
                if (this.selectedSeat === undefined && previouslyBoughtSeatIndexForSplice !== -1) {
                    // Seat has passenger - previouslyPurchasedSeat
                    this.deletedPreviouslyBoughtSeats.push(this.previouslyBoughtSeats[previouslyBoughtSeatIndexForSplice]);
                    this.previouslyBoughtSeats.splice(previouslyBoughtSeatIndexForSplice, 1);
                    this.hasChanges = true;
                    this.selectedSeat = undefined;
                }
                else if (this.selectedSeat === undefined && SEAT_WITH_PAX_1 !== -1) {
                    // Seat has passenger - newlyAddedSeat
                    this.hasChanges = true;
                    this.selectedSeat = undefined;
                    var BOUGHT_SEAT_PAX = this.newBoughtSeats.findIndex(function (boughtSeat) { return boughtSeat.passengerIndex === _this.choosedSeats[SEAT_WITH_PAX_1].passengerIndex; });
                    this.cdr.markForCheck();
                    this.newBoughtSeats.splice(BOUGHT_SEAT_PAX, 1);
                    this.choosedSeats.splice(SEAT_WITH_PAX_1, 1);
                    this.updateSeat(this.choosedSeats, this.newBoughtSeats);
                    /**
                     *  Removes selected seat from current copy of addedFeatures
                     */
                    var PAX_ADDED_FEATURE = this.featuresAdded.findIndex(function (feature) { return feature.value === seat.seatCode && feature.segmentId === _this.flightStop.idInfoSegment; });
                    this.featuresAdded.splice(PAX_ADDED_FEATURE, 1);
                }
                else {
                    // Seat has no passenger
                    this.selectedSeat = seat;
                    this.INDRA_handleSeatType(seat);
                    // // Seat is an emergency exit
                    if (seat.exit && seat.isClicked) {
                        this.exitSeatClicked = true;
                    }
                    else {
                        this.exitSeatClicked = false;
                    }
                    // Seat is not an emergency exit
                    this.isOpen = seat.isClicked ? true : false;
                    this.cdr.detectChanges();
                }
            }
        }
        else {
            //METHOD: SHOW FEATURES UPON HOVER
            this.INDRA_handleSeatType(seat);
        }
    };
    INDRASeatmapComponent.prototype.INDRA_handleSeatType = function (seat) {
        var seatCharactArray = Object.keys(this.seatCharacteristics);
        if (seat.preferredSeat && !seat.exit && seat.available && !this.hasBusinessCabin) {
            this.seatType = 'addMoreSidebars.seatmap.text.comfort';
            this.seatCharacteristicsType = 'comfort';
            this.seatFeatures = this.seatCharacteristics[seatCharactArray[0]].features;
            this.seatColor = this.seatCharacteristics[seatCharactArray[0]].cssClass;
        }
        if (seat.preferredSeat && !seat.exit && seat.extraLegSpace && seat.available) {
            this.seatType = 'addMoreSidebars.seatmap.text.legSpace';
            this.seatCharacteristicsType = 'legroom';
            this.seatFeatures = this.seatCharacteristics[seatCharactArray[1]].features;
            this.seatColor = this.seatCharacteristics[seatCharactArray[1]].cssClass;
        }
        if (!seat.preferredSeat && !seat.exit && seat.available && !this.hasBusinessCabin) {
            this.seatType = 'addMoreSidebars.seatmap.text.standard';
            this.seatCharacteristicsType = 'standard';
            this.seatFeatures = this.seatCharacteristics[seatCharactArray[2]].features;
            this.seatColor = this.seatCharacteristics[seatCharactArray[2]].cssClass;
        }
        if (this.INDRA_checkEmergencySeat(seat)) {
            this.seatType = 'addMoreSidebars.seatmap.text.exitRow';
            this.seatCharacteristicsType = 'emergency';
            this.seatFeatures = this.seatCharacteristics[seatCharactArray[4]].features;
            this.seatColor = this.seatCharacteristics[seatCharactArray[4]].cssClass;
        }
        if (this.hasBusinessCabin && seat.available) {
            this.seatType = 'addMoreSidebars.seatmap.text.executive';
            this.seatCharacteristicsType = 'business';
            this.seatFeatures = this.seatCharacteristics[seatCharactArray[3]].features;
            this.seatColor = this.seatCharacteristics[seatCharactArray[3]].cssClass;
        }
    };
    INDRASeatmapComponent.prototype.INDRA_checkEmergencySeat = function (seat) {
        return this.hasBusinessCabin ? ((seat.available && seat.exit) || (!seat.available && seat.exit)) : ((seat.exit && seat.available) || (!seat.available && seat.exit));
    };
    INDRASeatmapComponent.prototype.INDRA_buildSeatTypesList = function (row) {
        var _this = this;
        row.seatsByCode.forEach(function (seat) {
            if (seat.exit) {
                _this.planeSeatTypesList.add('emergency');
            }
            else {
                if (seat.preferredSeat) {
                    if (seat.extraLegSpace) {
                        _this.planeSeatTypesList.add('legroom');
                    }
                    else {
                        _this.planeSeatTypesList.add('comfort');
                    }
                }
                else {
                    _this.planeSeatTypesList.add('standard');
                }
            }
            if (_this.seatmapCabinClass === 'business') {
                _this.planeSeatTypesList.add('business');
            }
        });
    };
    INDRASeatmapComponent.prototype.INDRA_generateCabinStyle = function () {
        this.planeWing = new INDRAPlaneWing();
        var wingRowsCount = 0;
        this.planeSeatTypesList.clear();
        for (var _i = 0, _a = this.seatmap.cabins; _i < _a.length; _i++) {
            var cabin = _a[_i];
            var cabinType = this.flight.listSegment[this.selectedStop]['cabin'];
            if (cabin.location === 'C' || cabinType !== 'Economy') {
                this.hasBusinessCabin = true;
                this.hasEconomyCabin = false;
                this.seatmapCabinClass = 'business';
            }
            if (cabin.location === 'Y' || (!cabinType || cabinType === 'Economy')) {
                this.hasEconomyCabin = true;
                this.hasBusinessCabin = false;
                this.seatmapCabinClass = 'economy';
            }
            for (var _b = 0, _c = cabin.rows; _b < _c.length; _b++) {
                var row = _c[_b];
                this.INDRA_buildSeatTypesList(row);
                if (wingRowsCount > 0) {
                    // If wing has already started
                    // Keep counting to prevent intervals on the wing
                    // Count will be updated only if row.wing is true again
                    wingRowsCount++;
                }
                if (row.wing) {
                    if (this.planeWing.startRow === undefined) {
                        // First row with wing
                        wingRowsCount++;
                        /*this.planeWing.startRow = row.index;
                        this.planeWing.rowsCount = wingRowsCount;*/
                        this.planeWing = Object.assign(this.planeWing, { startRow: row.index, rowsCount: wingRowsCount });
                    }
                    else {
                        // Following rows with wing
                        this.planeWing = Object.assign(this.planeWing, { rowsCount: wingRowsCount });
                        // this.planeWing.rowsCount = wingRowsCount;
                    }
                }
            }
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getSeatCharacteristicsProps = function () {
        return Object.keys(this.seatCharacteristics);
    };
    INDRASeatmapComponent.prototype.INDRA_openSlideshow = function (type) {
        // const durationInHours = Math.floor(this.flightStop.duration / 60);
        // const seatImages: AssetInfo[] = this.bookingService.INDRA_getSeatImages(type, this.flightStop.equipment, durationInHours);
        var seatImages = [];
        this.seatCharacteristics[type].images.forEach(function (image) {
            var asset = {
                path_url: image.src,
                description: image.label,
            };
            seatImages.push(asset);
        });
        this.modalService.assignComponent(INDRASlideshowComponent, seatImages);
        this.modalService.open();
    };
    INDRASeatmapComponent.prototype.INDRA_confirmEmergencySeat = function () {
        this.emergencySeatNotificationOpen = false;
        this.restoreScrollPosition();
        this.INDRA_selectPassenger(this.passengers[this.exitSeatPassengerIndex], this.exitSeatPassengerIndex);
        this.selectedSeat = undefined;
    };
    INDRASeatmapComponent.prototype.INDRA_cancelEmergencySeat = function () {
        this.selectedSeat = undefined;
        this.emergencySeatNotificationOpen = false;
        this.restoreScrollPosition();
    };
    INDRASeatmapComponent.prototype.INDRA_confirmSaveConfirmationInfo = function () {
        this.isLoadingSeatmap = true;
        // this.INDRA_handleSeatsSelection();
        if (this.packCode) {
            this.sidebarService.previousSidebar();
            this.packService.selectSeats(this.packSeatSelection);
        }
        else {
            this.INDRA_handleAncillariesSelection();
        }
        /*
        if (this.selectionApiError === true) {
            this.isLoadingSeatmap = false;
        }
        this.saveConfirmationInfoOpen = false;
        */
    };
    INDRASeatmapComponent.prototype.INDRA_cancelSaveConfirmationInfo = function () {
        this.hasChanges = true;
        this.selectedSeat = undefined;
        this.saveConfirmationInfoOpen = false;
        this.sidebarService.previousSidebar();
    };
    INDRASeatmapComponent.prototype.INDRA_disableSave = function () {
        var totalChoosedSeats = 0;
        this.choosedSeatsStops.forEach(function (stop) {
            stop.seats.forEach(function (seat) { return totalChoosedSeats++; });
        });
        if (this.packCode && (totalChoosedSeats < (this.passengers.length * this.stops.length))) {
            return true;
        }
        return false;
    };
    INDRASeatmapComponent.prototype.INDRA_goNextFlight = function () {
    };
    INDRASeatmapComponent.prototype.closeSelectPassengerModal = function (seatSelected, event) {
        if (seatSelected === void 0) { seatSelected = true; }
        this.isOpen = false;
        if (this.exitSeatClicked && this.choosedSeats && seatSelected) {
            this.saveScrollPosition();
            this.topScrollPosition();
            this.exitSeatClicked = false;
            this.emergencySeatNotificationOpen = true;
        }
        else {
            this.selectedSeat = undefined;
        }
    };
    INDRASeatmapComponent.prototype.handleEscapeKeyboardEvent = function (event) {
        if (this.isOpen) {
            event.stopPropagation(); // stop propagation in order to don't handle the close of entire sidebar.
            this.closeSelectPassengerModal(false);
        }
    };
    INDRASeatmapComponent.prototype.INDRA_passengerClasses = function (passengerInfo, index) {
        var _this = this;
        var indexSeat = this.choosedSeats.map(function (cur) { return cur.passengerIndex; }).includes(index);
        var indexPurchasedSeat = this.previouslyBoughtSeats.findIndex(function (seats) { return seats.segmentId === _this.flightStop.idInfoSegment
            && seats.paxId === passengerInfo.idPax; });
        return { 'has-seat': (indexSeat || indexPurchasedSeat > -1), 'is-disabled': ((!this.selectedSeat.suitableChildren && passengerInfo.typePax == PAX_TYPE_CHILD_CODE) || (!this.selectedSeat.allowedInfant && passengerInfo.adtToInf)) };
    };
    INDRASeatmapComponent.prototype.INDRA_selectPassengerAction = function (passengerInfo, passengerIndex, existingSeat) {
        if (existingSeat === void 0) { existingSeat = null; }
        if (this.exitSeatClicked) {
            this.exitSeatPassengerIndex = passengerIndex;
            this.closeSelectPassengerModal();
        }
        else {
            this.INDRA_selectPassenger(passengerInfo, passengerIndex, existingSeat);
        }
    };
    INDRASeatmapComponent.prototype.INDRA_selectPassenger = function (passengerInfo, passengerIndex, existingSeat) {
        var _this = this;
        if (existingSeat === void 0) { existingSeat = null; }
        var seat = existingSeat ? existingSeat : this.selectedSeat;
        this.hasChanges = true;
        var choosedSeatsIndex = this.choosedSeats.findIndex(function (cur) { return cur.passengerIndex == passengerIndex; });
        var isUnaccompaniedMinor = false;
        if (passengerInfo.prm) {
            passengerInfo.prm.forEach(function (prmItem) {
                if (SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type) {
                    isUnaccompaniedMinor = true;
                }
            });
        }
        // Get price
        var newPrice;
        var newPoints;
        if ((passengerInfo.FFnum && passengerInfo.FFid === 'TP' && passengerInfo.tierLevelFF === TAP_MILES_AND_GO_GOLD) ||
            (seat !== undefined && !seat.prices.length) ||
            (isUnaccompaniedMinor && this.selectedSeat.suitableUnnacompaniedMinor)) {
            newPrice = 0;
            newPoints = 0;
        }
        else if (seat !== undefined) {
            var selectedSeatPricesForPax = seat.prices.filter(function (seatPrice) { return seatPrice.paxTatto === passengerInfo.tatoo && SEAT_PRICE_TICKET_AMOUNT_CODE === seatPrice.code; });
            if (selectedSeatPricesForPax.length > 0) {
                newPrice = selectedSeatPricesForPax[0].price;
                newPoints = selectedSeatPricesForPax[0].valuePoints;
            }
            else {
                newPrice = 0;
                newPoints = 0;
            }
        }
        // Update OR Add seat - Sidebar view seats (for presentation)
        if (choosedSeatsIndex !== -1) {
            // Update existing seat
            this.choosedSeats[choosedSeatsIndex].seat = seat.seatCode;
            this.choosedSeats[choosedSeatsIndex].price = newPrice;
            this.choosedSeats[choosedSeatsIndex].points = newPoints;
            this.choosedSeats[choosedSeatsIndex].seatDescription = seat.seatDescription;
            this.choosedSeats[choosedSeatsIndex].seatType = seat.type;
        }
        else {
            // Add new seat entry
            this.choosedSeats.push({
                passengerIndex: passengerIndex,
                seat: seat.seatCode,
                price: newPrice,
                points: newPoints,
                seatDescription: seat.seatDescription,
                seatType: seat.type
            });
        }
        // **FIX: Handle newBoughtSeats correctly**
        var BOUGHT_SEAT_PAX_INDEX = this.newBoughtSeats.findIndex(function (boughtSeat) { return boughtSeat.passengerIndex === passengerIndex; });
        // Remove existing featuresAdded entry for this passenger and segment
        var existingFeatureIndex = this.featuresAdded.findIndex(function (feature) {
            return feature.segmentId === _this.flightStop.idInfoSegment &&
                feature.paxId === passengerInfo.idPax &&
                feature.type === EXTRAS_ANCILLARY_SEAT;
        });
        if (existingFeatureIndex > -1) {
            this.featuresAdded.splice(existingFeatureIndex, 1);
        }
        // Update or add to newBoughtSeats
        if (BOUGHT_SEAT_PAX_INDEX !== -1) {
            // Update existing entry
            this.newBoughtSeats[BOUGHT_SEAT_PAX_INDEX].seat = seat.seatCode;
            this.newBoughtSeats[BOUGHT_SEAT_PAX_INDEX].price = newPrice;
            this.newBoughtSeats[BOUGHT_SEAT_PAX_INDEX].points = newPoints;
            this.newBoughtSeats[BOUGHT_SEAT_PAX_INDEX].seatDescription = seat.seatDescription;
            this.newBoughtSeats[BOUGHT_SEAT_PAX_INDEX].seatType = seat.type;
        }
        else {
            // Add new entry
            this.newBoughtSeats.push({
                passengerIndex: passengerIndex,
                seat: seat.seatCode,
                price: newPrice,
                points: newPoints,
                seatDescription: seat.seatDescription,
                seatType: seat.type
            });
        }
        // Handle previously bought seats removal
        var previouslyBoughtSeatIndex = this.previouslyBoughtSeats.findIndex(function (seat) {
            return seat.paxId === passengerInfo.idPax &&
                seat.segmentId === _this.flightStop.idInfoSegment;
        });
        if (previouslyBoughtSeatIndex > -1) {
            this.deletedPreviouslyBoughtSeats.push(this.previouslyBoughtSeats[previouslyBoughtSeatIndex]);
            this.previouslyBoughtSeats.splice(previouslyBoughtSeatIndex, 1);
        }
        this.updateSeat(this.choosedSeats, this.newBoughtSeats);
        this.closeSelectPassengerModal();
        if (this.packCode) {
            if (this.packSeatSelection[passengerInfo.idPax]) {
                this.packSeatSelection[passengerInfo.idPax][this.flightStop.idInfoSegment] = seat.seatCode;
            }
            else {
                this.packSeatSelection[passengerInfo.idPax] = {};
                this.packSeatSelection[passengerInfo.idPax][this.flightStop.idInfoSegment] = seat.seatCode;
            }
        }
    };
    INDRASeatmapComponent.prototype.updateSeat = function (choosed, newBought) {
        var _this = this;
        if (choosed === void 0) { choosed = null; }
        if (newBought === void 0) { newBought = null; }
        if (choosed) {
            var choosedSeats = this.choosedSeatsStops.find(function (cur) { return cur.id_stop == _this.selectedStop; });
            if (choosedSeats) {
                choosedSeats.seats = choosed;
            }
            else {
                this.choosedSeatsStops.push({
                    id_stop: this.selectedStop,
                    seats: choosed
                });
            }
        }
        if (newBought) {
            var newBoughtSeats = this.newBoughtSeatsStops.find(function (cur) { return cur.id_stop == _this.selectedStop; });
            if (newBoughtSeats) {
                newBoughtSeats.seats = newBought;
            }
            else {
                this.newBoughtSeatsStops.push({
                    id_stop: this.selectedStop,
                    seats: newBought
                });
            }
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getPassengers = function () {
        return this.passengers;
    };
    INDRASeatmapComponent.prototype.INDRA_passengerIsMilesGo = function (passenger) {
        return false;
    };
    INDRASeatmapComponent.prototype.INDRA_printPassengerTierLevel = function (passenger) {
        return ('Miles&Go ');
    };
    INDRASeatmapComponent.prototype.INDRA_printPassengerSeatLabel = function (passengerInfo, index) {
        var choosedSeatIndex = this.choosedSeats.findIndex(function (seat) { return (seat.passengerIndex === index); });
        var previouslyBoughtIndex = this.previouslyBoughtSeats.findIndex(function (seat) { return (seat.paxId === passengerInfo.idPax); });
        if (this.previouslyBoughtSeats[previouslyBoughtIndex] !== undefined &&
            this.previouslyBoughtSeats[previouslyBoughtIndex].value !== undefined &&
            this.flight.listSegment[this.selectedStop].idInfoSegment === this.previouslyBoughtSeats[previouslyBoughtIndex].segmentId // added filter to show correct flight segment
        ) {
            return this.previouslyBoughtSeats[previouslyBoughtIndex].value;
        }
        else if (this.choosedSeats[choosedSeatIndex] !== undefined &&
            this.choosedSeats[choosedSeatIndex].seat !== undefined) {
            return this.choosedSeats[choosedSeatIndex].seat;
        }
        else {
            return this.INDRA_getPassengerSeatPrice(passengerInfo, index);
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getPassengerSeatPrice = function (passengerInfo, index) {
        var isUnaccompaniedMinor = false;
        // let previouslyBoughtIndex = this.previouslyBoughtSeatsBeforeEdit.findIndex(seat => (seat.paxId === passengerInfo.idPax && seat.segmentId === this.flightStop.idInfoSegment));
        if (passengerInfo.prm) {
            passengerInfo.prm.forEach(function (prmItem) {
                if (SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type) {
                    isUnaccompaniedMinor = true;
                }
            });
        }
        if ((passengerInfo.FFid === 'TP' &&
            passengerInfo.tierLevelFF === TAP_MILES_AND_GO_GOLD) ||
            (this.selectedSeat !== undefined && !this.selectedSeat.prices.length) ||
            (isUnaccompaniedMinor && this.selectedSeat.suitableUnnacompaniedMinor)) {
            return this.currencyService.INDRA_formatCash('0') + ' ' + this.INDRA_getSeatmapCurrencySymbol();
        }
        else if (this.selectedSeat !== undefined) {
            var selectedSeatPricesForPax = this.selectedSeat.prices.filter(function (seatPrice) { return seatPrice.paxTatto === passengerInfo.tatoo && SEAT_PRICE_TICKET_AMOUNT_CODE === seatPrice.code; });
            if (selectedSeatPricesForPax.length > 0) {
                return this.currencyService.INDRA_formatCash(selectedSeatPricesForPax[0].price) + " " + this.INDRA_getSeatmapCurrencySymbol();
            }
            else {
                return this.currencyService.INDRA_formatCash('0,00') + " " + this.INDRA_getSeatmapCurrencySymbol();
            }
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getPassengerSeatMnbPrice = function (passengerInfo, index) {
        var isUnaccompaniedMinor = false;
        if (passengerInfo.prm) {
            passengerInfo.prm.forEach(function (prmItem) {
                if (SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type) {
                    isUnaccompaniedMinor = true;
                }
            });
        }
        if ((passengerInfo.FFid === 'TP' &&
            passengerInfo.tierLevelFF === TAP_MILES_AND_GO_GOLD) ||
            (this.selectedSeat !== undefined && !this.selectedSeat.prices.length) ||
            (isUnaccompaniedMinor && this.selectedSeat.suitableUnnacompaniedMinor)) {
            return this.currencyService.INDRA_formatCash('0') + ' ' + this.INDRA_getSeatmapCurrencySymbol();
        }
        else if (this.selectedSeat !== undefined) {
            var selectedSeatPricesForPax = this.selectedSeat.prices.filter(function (seatPrice) { return seatPrice.paxTatto === passengerInfo.tatoo && SEAT_PRICE_TICKET_AMOUNT_CODE === seatPrice.code; });
            if (selectedSeatPricesForPax.length > 0) {
                if (selectedSeatPricesForPax[0].mnbPrice != null) {
                    return this.currencyService.INDRA_formatCash(selectedSeatPricesForPax[0].mnbPrice) + " " + this.INDRA_getSeatmapCurrencySymbol();
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getSeatmapCurrencySymbol = function () {
        if (!this.seatmap && !this.seatmap.currency) {
            return '';
        }
        else {
            if (this.seatmap.currency) {
                return this.INDRA_getCurrencySymbol(this.seatmap.currency);
            }
            else {
                return this.currencyService.INDRA_getCurrencySymbol().unit;
            }
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getSelectedSeat = function () {
        return this.selectedSeat.seatCode;
    };
    /**
     * Return the number of added items in this sidebar
     */
    INDRASeatmapComponent.prototype.INDRA_printItemsCount = function () {
        return this.newBoughtSeatsStops.reduce(function (acc, cur) { return acc += cur.seats.filter(function (boughtSeat) { return boughtSeat.seat !== undefined; }).length; }, 0);
    };
    /**
     * @returns print-ready string of value of added ancillaries
     */
    INDRASeatmapComponent.prototype.INDRA_printTotal = function () {
        var total = this.newBoughtSeatsStops.reduce(function (acc, cur) { return acc += cur.seats.reduce(function (accSeat, curSeat) { return accSeat += curSeat.price; }, 0); }, 0);
        return this.currencyService.INDRA_formatCash(total) + this.INDRA_getSeatmapCurrencySymbol();
    };
    INDRASeatmapComponent.prototype.INDRA_flowActionsClasses = function () {
        // return { 'flow_actions--wide': !this.INDRA_hasNextFlight() };
        return { 'flow_actions--wide': false };
    };
    /**
     * Handles next flight click;
     * If there is a next flight, navigate to seatmap of with the next flight id;
     * Else, Close the sidebar
     */
    INDRASeatmapComponent.prototype.INDRA_handleNext = function () {
        this.confirmToGoNext = true;
        this.hasChanges = false;
        this.saveConfirmationInfoOpen = true;
    };
    INDRASeatmapComponent.prototype.INDRA_hasNextFlight = function () {
        // return this.booking.flights && this.booking.flights.length > 1;
    };
    INDRASeatmapComponent.prototype.INDRA_handleOpenCharacteristics = function () {
        this.saveScrollPosition();
        this.topScrollPosition();
        this.seatCharacteristicsOpen = true;
    };
    INDRASeatmapComponent.prototype.INDRA_handleCloseCharacteristics = function () {
        this.seatCharacteristicsOpen = false;
        this.restoreScrollPosition();
    };
    INDRASeatmapComponent.prototype.INDRA_getLocation = function (code) {
        return this.bookingService.INDRA_getLocation(code).city;
    };
    INDRASeatmapComponent.prototype.INDRA_addAncillariesSelection = function () {
        var _this = this;
        // deletes replaced/removed seats
        this.featuresAddedBeforeEdit.forEach(function (previouslyAddedfeature) {
            // checks if seat has been changed for the pax on the segment
            var seatChangedIndex = _this.featuresAdded.findIndex(function (seat) { return (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(seat.type)
                && seat.paxId === previouslyAddedfeature.paxId
                && seat.flightId === previouslyAddedfeature.flightId
                && seat.segmentId === previouslyAddedfeature.segmentId
                && seat.value !== previouslyAddedfeature.value); });
            // checks if seat has been removed for the pax on the segment
            var seatRemoveIndex = _this.featuresAdded.findIndex(function (seat) { return (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(seat.type)
                && seat.paxId === previouslyAddedfeature.paxId
                && seat.flightId === previouslyAddedfeature.flightId
                && seat.segmentId === previouslyAddedfeature.segmentId); });
            if ((seatChangedIndex > -1 || seatRemoveIndex < 0) && (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(previouslyAddedfeature.type))) {
                _this.INDRA_handleRemoveSegmentAncillary(previouslyAddedfeature, previouslyAddedfeature.segmentId);
            }
        });
        // deletes replaced/removed seats
        this.previouslyBoughtSeatsBeforeEdit.forEach(function (previouslyBoughtFeature) {
            // checks if seat has been changed for the pax on the segment
            var seatChangedIndex = _this.previouslyBoughtSeats.findIndex(function (seat) { return (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(seat.type)
                && seat.paxId === previouslyBoughtFeature.paxId
                && seat.flightId === previouslyBoughtFeature.flightId
                && seat.segmentId === previouslyBoughtFeature.segmentId
                && seat.value !== previouslyBoughtFeature.value); });
            // checks if seat has been removed for the pax on the segment
            var seatRemoveIndex = _this.previouslyBoughtSeats.findIndex(function (seat) { return (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(seat.type)
                && seat.paxId === previouslyBoughtFeature.paxId
                && seat.flightId === previouslyBoughtFeature.flightId
                && seat.segmentId === previouslyBoughtFeature.segmentId); });
            var deletedSeatIndex = _this.bfmService.INDRA_getDeletedPreviouslyPurchasedSeats().findIndex(function (feature) { return (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(feature.type)
                && feature.paxId === previouslyBoughtFeature.paxId
                && feature.flightId === previouslyBoughtFeature.flightId
                && feature.segmentId === previouslyBoughtFeature.segmentId); });
            if (((seatChangedIndex > -1 || seatRemoveIndex < 0) && deletedSeatIndex < 0) || // scenario: there's already previously bought seat that was deleted..
                (_this.bfmService.INDRA_getDeletedPreviouslyPurchasedSeats().length === 0 && (seatChangedIndex > -1 || seatRemoveIndex < 0)) // scenario: no previously bought seat was deleted yet (initial load)..
                    && (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(previouslyBoughtFeature.type))) {
                _this.INDRA_handleRemoveSegmentAncillary(previouslyBoughtFeature, previouslyBoughtFeature.segmentId);
            }
        });
        this.paxAddedFeature = [];
        // adds only newly selected seats
        this.newBoughtSeatsStops.forEach(function (seatStops) {
            seatStops.seats.forEach(function (boughtSeat) {
                if (boughtSeat.seat) {
                    var idPax = _this.passengers[boughtSeat.passengerIndex].idPax;
                    var segmentId_1 = _this.flight.listSegment[seatStops.id_stop].idInfoSegment;
                    var addOnSeat = _this.INDRA_getAddOnForPassenger(idPax).filter(function (addOn) { return addOn.segmentId === segmentId_1; })[0];
                    var newAddedItem_1 = {
                        value: boughtSeat.seat,
                        price: boughtSeat.price,
                        currency: _this.seatmapCurrency,
                        paxId: idPax,
                        type: EXTRAS_ANCILLARY_SEAT,
                        code: EXTRAS_ANCILLARY_SEAT_SSR,
                        segmentId: _this.flight.listSegment[seatStops.id_stop].idInfoSegment,
                        flightId: _this.flight.idFlight,
                        flightCardId: _this.flightCardId,
                        itemId: addOnSeat ? addOnSeat.itemId : undefined,
                        flightBased: false,
                        paxTatto: addOnSeat ? addOnSeat.paxTatto : undefined,
                        enabled: true,
                        maxQuantity: 1,
                        points: boughtSeat.points,
                        seatDescription: boughtSeat.seatDescription,
                        seatType: boughtSeat.seatType,
                        serviceCode: null
                    };
                    var featureAddedIndex = _this.featuresAddedBeforeEdit.findIndex(function (seat) {
                        return ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(seat.type)
                            && seat.paxId === newAddedItem_1.paxId
                            && seat.flightId === newAddedItem_1.flightId
                            && seat.segmentId === newAddedItem_1.segmentId
                            && seat.value === newAddedItem_1.value;
                    });
                    var featureDeletedIndex = _this.paxDeletedFeatures.findIndex(function (seat) {
                        return ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(seat.type)
                            && seat.paxId === newAddedItem_1.paxId
                            && seat.flightId === newAddedItem_1.flightId
                            && seat.segmentId === newAddedItem_1.segmentId
                            && seat.value === newAddedItem_1.value;
                    });
                    // add only seat is if not previously added OR is being deleted and readded currently
                    if (featureAddedIndex < 0 || featureDeletedIndex >= 0) {
                        _this.INDRA_handleAddAncillary(newAddedItem_1);
                    }
                }
            });
        });
    };
    INDRASeatmapComponent.prototype.INDRA_displayWCCabinFacility = function (cabin, rowLocation, rowIdx) {
        var flag = false;
        if (cabin.facilities && cabin.facilities.length > 0) {
            var cabinFacilities = cabin.facilities;
            cabinFacilities.forEach(function (facility) {
                if (facility.rowLocation
                    && facility.rowLocation.toLowerCase().includes(rowLocation)
                    && facility.type === 'WC' && facility.location && rowIdx == facility.location) {
                    flag = true;
                }
            });
        }
        return flag;
    };
    INDRASeatmapComponent.prototype.INDRA_isSelectedSeatSuitableForPax = function (passengerInfo) {
        var flag = false;
        var carriedWheelchair = false;
        if (this.selectedSeat) {
            if (passengerInfo.prm && passengerInfo.prm.length > 0) {
                passengerInfo.prm.forEach(function (prm) {
                    if (prm.type === SSR_CODE_WHEELCHAIR_CARRY) {
                        carriedWheelchair = true;
                    }
                });
                if ((carriedWheelchair && this.selectedSeat.handicappedFacilities) || // passenger with WCHC assistance would be be able to select seats that are suitable for handicapped..
                    (!carriedWheelchair)) {
                    flag = true;
                }
            }
            else {
                // passenger with no restriction should be able to select all available seats..
                flag = true;
            }
            if (!this.ancillariesService.INDRA_isCurrentPurchasedAncillariesEligible(this.flight.idFlight.toString(), this.flightStop.idInfoSegment.toString(), passengerInfo.idPax.toString(), PURCHASED_ANCILLARY_SEAT.ineligibleSSR)) {
                flag = false;
            }
        }
        return flag;
    };
    INDRASeatmapComponent.prototype.INDRA_getSeatsForPassenger = function (list, idPax) {
        var returnValue = '';
        var index = list.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (list && index >= 0) {
            var paxAncillary = list[index];
            returnValue = paxAncillary[idPax];
        }
        return returnValue;
    };
    INDRASeatmapComponent.prototype.INDRA_isSelectedSeatSuitableHasCharacteristic = function (code) {
        var returnValue = false;
        var key = this.INDRA_getKeyBySeatCharacteristics(code);
        if (this.selectedSeat && this.selectedSeat.characteristics && this.selectedSeat.characteristics.includes(code) && this.seatFeatures && !this.seatFeatures.includes(key) && !this.seatFeatures.includes('addMoreSidebars.seatmap.text.noRecline')) {
            returnValue = true;
        }
        return returnValue;
    };
    INDRASeatmapComponent.prototype.INDRA_getKeyBySeatCharacteristics = function (code) {
        switch (code) {
            case 'PETC':
            case 'PC':
                return 'addMoreSidebars.seatmap.text.suitableForPet';
            case 'BSCT':
            case 'B':
                return 'addMoreSidebars.seatmap.text.suitableForBassinet';
            case '1D':
                return 'addMoreSidebars.seatmap.text.notReclinableSeats';
        }
    };
    INDRASeatmapComponent.prototype.INDRA_stopHasPurchasedCode = function (code) {
        return this.bookingService.INDRA_hasPurchasedAncillaryCodeOnSegment(code, this.flightCardId, this.flightStop.idInfoSegment.toString()) ||
            this.bookingService.INDRA_hasAncillary(code, this.flight.idFlight.toString());
    };
    INDRASeatmapComponent.prototype.INDRA_deriveSeatPriceFromSeatmap = function (boughtSeats) {
        var _this = this;
        boughtSeats.forEach(function (boughtSeat) {
            var seatmapIndex = _this.segmentsSeatmap.findIndex(function (object) { return object[boughtSeat.segmentId]; });
            var segmentSeatmapObject = _this.segmentsSeatmap[seatmapIndex];
            var passengerInfo = _this.INDRA_getPassengerInfo(boughtSeat.paxId);
            var priceFoundForBoughtSeat = false;
            if (seatmapIndex !== -1) {
                var seatmap = segmentSeatmapObject[_this.flightStop.idInfoSegment];
                if (seatmap) {
                    seatmap.cabins.forEach(function (cabin) {
                        if (!priceFoundForBoughtSeat) {
                            cabin.rows.forEach(function (row) {
                                if (!priceFoundForBoughtSeat) {
                                    row.seatsByCode.forEach(function (seat) {
                                        if (!priceFoundForBoughtSeat && seat.seatCode === boughtSeat.value) {
                                            var seatPrices = seat.prices.filter(function (seatPrice) {
                                                return seatPrice.paxTatto === passengerInfo.tatoo
                                                    && SEAT_PRICE_TICKET_AMOUNT_CODE === seatPrice.code;
                                            });
                                            if (seatPrices.length > 0) {
                                                boughtSeat.price = seatPrices[0].price;
                                            }
                                            else {
                                                boughtSeat.price = 0;
                                            }
                                            priceFoundForBoughtSeat = true;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        });
        return boughtSeats;
    };
    INDRASeatmapComponent.prototype.INDRA_getPassengerInfo = function (idPax) {
        return this.passengers.find(function (pax) { return pax.idPax === idPax; });
    };
    INDRASeatmapComponent.prototype.INDRA_showSeatPhotos = function (type) {
        var flag = true;
        // const durationInHours = Math.floor(this.flightStop.duration / 60);
        // const seatImages: AssetInfo[] = this.bookingService.INDRA_getSeatImages(type, this.flightStop.equipment, durationInHours);
        var seatImages = [];
        if (this.seatCharacteristics[type].images) {
            this.seatCharacteristics[type].images.forEach(function (image) {
                var asset = {
                    path_url: image.src,
                    description: image.label,
                };
                seatImages.push(asset);
            });
        }
        if (seatImages.length === 0) {
            flag = false;
        }
        return flag;
    };
    INDRASeatmapComponent.prototype.INDRA_seatRemoved = function () {
        if (this.newBoughtSeats.length === 0)
            return true;
        else
            return false;
    };
    INDRASeatmapComponent.prototype.INDRA_isCabinClassEconomy = function () {
        return this.seatmapCabinClass === 'economy';
    };
    INDRASeatmapComponent.prototype.INDRA_isCabinClassBusiness = function () {
        return this.seatmapCabinClass === 'business';
    };
    INDRASeatmapComponent.prototype.INDRA_updatePageModel = function (idInfoSegment, finalMap) {
        var _this = this;
        this.seatCharacteristicsBySegmentBySeatTypeMap.set(idInfoSegment, finalMap);
        finalMap.forEach(function (value, key) { return _this.seatCharacteristics[key].features = finalMap.get(key); });
    };
    INDRASeatmapComponent.prototype.INDRA_updateSeatCharacteristicsMap = function (idInfoSegment) {
        var _this = this;
        var finalMap = this.seatCharacteristicsBySegmentBySeatTypeMap.get(idInfoSegment);
        if (finalMap) {
            finalMap.forEach(function (value, key) { return _this.seatCharacteristics[key].features = finalMap.get(key); });
        }
    };
    INDRASeatmapComponent.prototype.INDRA_getPriceDisplay = function () {
        var _this = this;
        var ancillaryLowestPrice;
        var currencySymbol;
        if (this.flight) {
            var priceFilter_1 = {
                idFlight: this.flight.idFlight,
                listSegmentId: this.flight.listSegment.map(function (segment) { return segment.idInfoSegment + ''; })
            };
            var lowestPriceTemp_1 = null;
            var activeBookedTrip = this.bfmService.INDRA_getActiveBookedTrip();
            if (activeBookedTrip && activeBookedTrip['ancillaries-data']['bundleList']) {
                var bundleList = activeBookedTrip["ancillaries-data"]['bundleList'];
                bundleList.forEach(function (bundleItem) {
                    bundleItem.ancillaryList.forEach(function (ancillaryItem) {
                        if (ancillaryItem && ancillaryItem.catalog && ancillaryItem.catalog.length > 0 &&
                            ancillaryItem.type === EXTRAS_ANCILLARY_SEAT) {
                            ancillaryItem.catalog.forEach(function (catalogItem) {
                                if (catalogItem.segmentId && catalogItem.flightId === priceFilter_1.idFlight
                                    && priceFilter_1.listSegmentId.includes(catalogItem.segmentId.toString())) {
                                    if (catalogItem.passengers.length > 0) {
                                        var itemPrices = catalogItem.passengers[0].codeList.map(function (item) { return Number(item.price); });
                                        if (!currencySymbol && catalogItem.passengers[0].codeList[0].currency) {
                                            currencySymbol = _this.INDRA_getCurrencySymbol(catalogItem.passengers[0].codeList[0].currency);
                                        }
                                        var sum = itemPrices.reduce(function (total, amount) {
                                            return total + amount;
                                        }, 0.00);
                                        if (_this.hasUnaccompaniedMinor && !_this.allPaxAreUnaccompaniedMinor) {
                                            lowestPriceTemp_1 = '0.00';
                                            //ancillaryLowestPrice = this.INDRA_getTranslation('addMoreSidebars.text.from') + ' ' + this.currencyService.INDRA_formatCash(0) + currencySymbol;
                                        }
                                        else {
                                            var tempAncillaryPricetext = (sum == Number(0.00) ? 'for free' : Math.min.apply(Math, itemPrices).toString());
                                            if (lowestPriceTemp_1 != null) {
                                                if (lowestPriceTemp_1 === 'for free') {
                                                    if (tempAncillaryPricetext !== 'for free') {
                                                        lowestPriceTemp_1 = tempAncillaryPricetext;
                                                    }
                                                }
                                                else {
                                                    lowestPriceTemp_1 = parseFloat(lowestPriceTemp_1) <= parseFloat(tempAncillaryPricetext) ? lowestPriceTemp_1 : tempAncillaryPricetext;
                                                }
                                            }
                                            else {
                                                lowestPriceTemp_1 = tempAncillaryPricetext;
                                            }
                                            //ancillaryLowestPrice = (sum == Number(0.00) ? this.INDRA_getTranslation('addMoreSidebars.text.forFree') : this.INDRA_getTranslation('addMoreSidebars.text.from') + ' ' + this.currencyService.INDRA_formatCash(Math.min(...itemPrices)) + ' ' + currencySymbol);
                                        }
                                    }
                                }
                            });
                        }
                    });
                });
                if (lowestPriceTemp_1 != null) {
                    if (lowestPriceTemp_1 === 'for free') {
                        ancillaryLowestPrice = this.INDRA_getTranslation('addMoreSidebars.text.forFree');
                    }
                    else {
                        ancillaryLowestPrice = this.INDRA_getTranslation('addMoreSidebars.text.from') + ' ' + this.currencyPipe.transform(lowestPriceTemp_1) + currencySymbol;
                    }
                }
            }
        }
        return ancillaryLowestPrice;
    };
    INDRASeatmapComponent.prototype.INDRA_printInfantName = function (paxId) {
        var passengers = this.bookingService.INDRA_getPaxInfo();
        var infant = passengers.find(function (pax) { return pax.idPax === paxId; });
        return infant ? this.INDRA_printPassengerName(infant) : '';
    };
    INDRASeatmapComponent.prototype.INDRA_goToExemptionURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    INDRASeatmapComponent.prototype.INDRA_checkAncillaryInPack = function () {
        var _this = this;
        var activeBookedTrip = this.bfmService.INDRA_getActiveBookedTrip();
        if (this.shoppingCartContent.itemsAdded.length) {
            this.shoppingCartContent.itemsAdded.forEach(function (item) {
                if (ANCILLARY_PRODUCT_PACKS.includes(item.code)) {
                    // Item is pack
                    for (var i = 0; i < activeBookedTrip['ancillaries-data'].packList.length; i++) {
                        var pack = activeBookedTrip['ancillaries-data'].packList[i];
                        if (pack.ancillaryList[0].type === item.code && item.segmentId === _this.flightStop.idInfoSegment) {
                            if (pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.find(function (anc) { return anc.code === EXTRAS_ANCILLARY_SEAT_SSR; })) {
                                _this.addedByPack = true;
                                return;
                            }
                        }
                        else {
                            _this.addedByPack = false;
                        }
                    }
                }
            });
        }
    };
    return INDRASeatmapComponent;
}(INDRAExtraSidebar));
export { INDRASeatmapComponent };
